import { motion } from 'framer-motion';
import { generatePath, Navigate, useNavigate, useParams } from 'react-router-dom';

import { useGetBuildingsByIdQuery } from '@client/api';
import { PageDetailContent } from '@client/toolkit';

import { PortfolioPaths } from '../../../portfolio.router';
import { BuildingEditInline } from './building-edit-inline.component';

export const BuildingEditRoute = () => {
  const { buildingId } = useParams<{ buildingId: string }>();
  const navigate = useNavigate();

  const { data: building, isFetching, isError } = useGetBuildingsByIdQuery({
    id: buildingId ?? '',
  }, { skip: buildingId == null });

  const handleCancel = () => {
    navigate(generatePath(PortfolioPaths.Building, { buildingId }), { replace: true });
  };

  const handleAfterSubmit = () => {
    navigate(generatePath(PortfolioPaths.Building, { buildingId }), { replace: true });
  };

  if (buildingId == null || isError) {
    return (
      <Navigate to={generatePath(PortfolioPaths.BuildingList)} replace />
    );
  }

  return (
    <PageDetailContent align="left">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{
          opacity: { ease: 'linear', duration: 0.2 },
          y: { ease: 'easeInOut', duration: 0.4 },
        }}
        className="space-y-2"
      >
        <BuildingEditInline
          building={building}
          isFetching={isFetching}
          onAfterSubmit={handleAfterSubmit}
          onCancel={handleCancel}
        />
      </motion.div>
    </PageDetailContent>
  );
};
